import { InjectionKey } from "vue"

import { createStore, useStore as baseUseStore, Store } from "vuex"

const stopAllVideos = new Event("stopAllVideos")

export interface Tutorial {
  id: string
  text: string
  toComplete: () => boolean
  completed: boolean
}

export interface State {
  page: Record<string, any>
  api: string
}

export const key: InjectionKey<Store<State>> = Symbol()

export const store = createStore<State>({
  state() {
    return {
      page: {},
      api: import.meta.env.VITE_KIRBY_URL,
    }
  },
  actions: {
    stopAllVideos() {
      window.dispatchEvent(stopAllVideos)
    },
  },
  mutations: {},
  getters: {},
})

export function useStore() {
  return baseUseStore(key)
}
